import { industries } from "@/data/industries";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { QuoteButton } from "@/components/CtaButtons";
import { business } from "@/config/business";

export const IndustriesSection = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="bg-[#F8FAFC] py-20 sm:py-24 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          chapter="04"
          kicker="Untuk Bisnis"
          title="Solusi Maintenance untuk Berbagai Jenis Bisnis"
          description="Layanan SEJUKARA diarahkan untuk kebutuhan perusahaan dan fasilitas komersial di berbagai sektor."
        />

        <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {industries.map((industry, i) => {
            const Icon = industry.icon;
            return (
              <Reveal key={industry.id} delay={(i % 4) * 0.06}>
                <article
                  data-testid={`industry-card-${industry.id}`}
                  className="group h-full rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-16px_rgba(15,23,42,0.18)]"
                >
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-slate-200 bg-[#F8FAFC] text-[#0F172A] transition-colors duration-300 group-hover:border-[#25D366]/40 group-hover:bg-[#25D366]/10 group-hover:text-[#25D366]">
                    <Icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-5 text-base font-bold text-slate-900">
                    {industry.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-600">
                    {industry.description}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex justify-center">
            <QuoteButton
              label="Request Survey & Penawaran"
              source="industries"
              size="lg"
              variant="accent"
              testId="industries-quote-cta"
              className="!bg-[#25D366] !text-white hover:!bg-[#1eb85a]"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default IndustriesSection;
